import * as React from 'react';
export var QuestionnaireContext = React.createContext([]);
export var QuestionnaireProvider = function (_a) {
    var children = _a.children;
    var _b = React.useState(), questionnaire = _b[0], setQuestionnaire = _b[1];
    var value = [questionnaire, setQuestionnaire];
    return React.createElement(QuestionnaireContext.Provider, { value: value }, children);
};
